import { render, staticRenderFns } from "./HelpCms.vue?vue&type=template&id=e22f848c"
import script from "./HelpCms.vue?vue&type=script&lang=js"
export * from "./HelpCms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports